import axios from '../base/axios';
import API_KEY from './key';

const GET_TVWARANDPOLITICS = 'flixfrenzy/redux/GET_TVWARANDPOLITICS';

// eslint-disable-next-line default-param-last
const tvWarAndPoliticsReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVWARANDPOLITICS:
      return action.payload;
    default:
      return state;
  }
};

export const getTvWarAndPolitics = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=10768`).then((res) => {
    dispatch({
      type: GET_TVWARANDPOLITICS,
      payload: res.data,
    });
  });
};

export default tvWarAndPoliticsReducer;
